import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const Tabs = ({ tabs, activeId, onChange, className }) => (
	<div className={twMerge('overflow-x-auto', className)}>
		<nav role="tablist" className="flex min-w-max gap-6 border-b border-bgBase-500">
			{tabs.map(({ id, label, icon: Icon, count }) => {
				const isActive = id === activeId;
				return (
					<button
						key={id}
						type="button"
						role="tab"
						aria-selected={isActive}
						onClick={() => onChange(id)}
						className={`inline-flex items-center gap-2 -mb-px whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors ${
							isActive
								? 'border-primary-500 text-primary-700'
								: 'border-transparent text-bgBase-800 hover:border-bgBase-600 hover:text-text'
						}`}
					>
						{Icon && <Icon className="h-4 w-4 flex-shrink-0" />}
						{label}
						{count !== undefined && count !== null && (
							<span
								className={`rounded-full px-1.5 text-xs ${
									isActive ? 'bg-primary-200 text-primary-700' : 'bg-bgBase-400 text-bgBase-800'
								}`}
							>
								{count}
							</span>
						)}
					</button>
				);
			})}
		</nav>
	</div>
);

Tabs.propTypes = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.node.isRequired,
			icon: PropTypes.elementType,
			count: PropTypes.number,
		}),
	).isRequired,
	activeId: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	className: PropTypes.string,
};

export default Tabs;
